var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"tab-content"},[_c('h2',[_vm._v(_vm._s(_vm.type && _vm.list[_vm.type]['tit']))])]),_c(_vm.type && _vm.list[_vm.type]['com'],{tag:"component",attrs:{"data":_vm.data},on:{"changeTab":_vm.tab}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }